<template>
  <div>
    <b-tabs pills>
      <!-- <b-tab title="Todos" active>
        <b-overlay :show="showLoadingPartidos" rounded="sm">
          <b-row>
            <b-col v-for="item in listTutoriales" :key="item.id" md="4">
              <b-card class="ecommerce-card" no-body>
                <b-embed
                  type="video"
                  aspect="16by9"
                  controls
                  :src="item.url"
                  allowfullscreen
                  class="mt-1"
                />
                <b-card-body>
                  <h6 class="item-name">{{ item.titulo }}</h6>

                  <div class="prueba">
                    {{ item.descripcion }}
                  </div>
                </b-card-body>
              </b-card>
            </b-col>
          </b-row>
        </b-overlay>
      </b-tab> -->
      <b-tab title="Inicial" @click="getVideosSeccion('inicial')">
        <b-overlay :show="showLoadingPartidos" rounded="sm">
          <b-row>
            <b-col v-for="item in listTutorialesSeccion" :key="item.id" md="4">
              <item-video
                :item="item"
                @quitarLista="quitarLista($event)"
              ></item-video>
            </b-col>
          </b-row>
        </b-overlay>
      </b-tab>
      <b-tab
        v-if="USER().rol !== ROLES.CLUB"
        title="Configuracion"
        @click="getVideosSeccion('configuracion')"
      >
        <b-overlay :show="showLoadingPartidos" rounded="sm">
          <b-row>
            <b-col v-for="item in listTutorialesSeccion" :key="item.id" md="4">
              <item-video :item="item"></item-video>
            </b-col>
          </b-row>
        </b-overlay>
      </b-tab>
      <b-tab
        v-if="
          USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.CALIFICACION ||
            USER().rol === ROLES.CLUB
        "
        title="Inscripciones"
        @click="getVideosSeccion('inscripciones')"
      >
        <b-overlay :show="showLoadingPartidos" rounded="sm">
          <b-row>
            <b-col v-for="item in listTutorialesSeccion" :key="item.id" md="4">
              <item-video :item="item"></item-video>
            </b-col>
          </b-row>
        </b-overlay>
      </b-tab>
      <b-tab
        v-if="
          USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.CALIFICACION
        "
        title="Calificaciones"
        @click="getVideosSeccion('calificaciones')"
      >
        <b-overlay :show="showLoadingPartidos" rounded="sm">
          <b-row>
            <b-col v-for="item in listTutorialesSeccion" :key="item.id" md="4">
              <item-video :item="item"></item-video>
            </b-col>
          </b-row>
        </b-overlay>
      </b-tab>
      <b-tab
        v-if="
          USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.TECNICA
        "
        title="Tecnica"
        @click="getVideosSeccion('tecnica')"
      >
        <b-overlay :show="showLoadingPartidos" rounded="sm">
          <b-row>
            <b-col v-for="item in listTutorialesSeccion" :key="item.id" md="4">
              <item-video :item="item"></item-video>
            </b-col>
          </b-row>
        </b-overlay>
      </b-tab>
      <b-tab
        v-if="
          USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.SANCIONES
        "
        title="Sanciones"
        @click="getVideosSeccion('sanciones')"
      >
        <b-overlay :show="showLoadingPartidos" rounded="sm">
          <b-row>
            <b-col v-for="item in listTutorialesSeccion" :key="item.id" md="4">
              <item-video :item="item"></item-video>
            </b-col>
          </b-row>
        </b-overlay>
      </b-tab>
      <b-tab
        v-if="
          USER().rol === ROLES.SUPER ||
            USER().rol === ROLES.ADMIN ||
            USER().rol === ROLES.TESORERIA
        "
        title="Tesoreria"
        @click="getVideosSeccion('tesoreria')"
      >
        <b-overlay :show="showLoadingPartidos" rounded="sm">
          <b-row>
            <b-col v-for="item in listTutorialesSeccion" :key="item.id" md="4">
              <item-video :item="item"></item-video>
            </b-col>
          </b-row>
        </b-overlay>
      </b-tab>
      <b-tab title="Varios" @click="getVideosSeccion('varios')">
        <b-overlay :show="showLoadingPartidos" rounded="sm">
          <b-row>
            <b-col v-for="item in listTutorialesSeccion" :key="item.id" md="4">
              <item-video :item="item"></item-video>
            </b-col>
          </b-row>
        </b-overlay>
      </b-tab>
    </b-tabs>
  </div>
</template>
<script>
import {
  BTabs,
  BTab,
  //   BCard,
  //   BCardBody,
  // BFormInput,
  // BTable,
  // BFormDatepicker,
  BRow,
  BCol,
  BOverlay,
  //   BButton,
  VBTooltip,
  //   BEmbed,
  // BRow,
  // BCol,
  // BBadge,
  // BPopover,

  //   cxxx
} from 'bootstrap-vue'
// import vSelect from 'vue-select'
import store from '@/store'
// import store from '@/store'
import {
  computed,
  onMounted,
  ref,
  reactive,
  // onActivated,
} from '@vue/composition-api'
import apiCall from '../../utils/apiCall'
import {
  USER,
  ROLES,
  URL_ADMINISTRACION,
  // xxx,
} from '../../utils/variables'
import ItemVideo from './ItemVideo.vue'

export default {
  components: {
    BTabs,
    BTab,
    // BCard,
    // BCardBody,
    BRow,
    BCol,
    // BEmbed,
    // BFormInput,
    // BTable,
    // BFormDatepicker,
    // vSelect,
    // BRow,
    // BCol,
    BOverlay,
    // BButton,
    ItemVideo,
  },
  directives: {
    'b-tooltip': VBTooltip,
  },
  setup() {
    const { getApi } = apiCall()
    const searchQuery = ref('')
    const showLoadingPartidos = ref(false)
    const listTutoriales = ref([])
    const listTutorialesSeccion = ref([])
    const listTutorialesNoEstanSeccion = ref([])
    const selected = ref({})
    const seccion = ref('')
    const accion = ref('i')
    const dataNoticia = ref({
      titulo: '',
      descripcion: '',
    })
    const dataNoticiaData = reactive({
      titulo: '',
      descripcion: '',
    })

    function editarNoticia(item) {
      accion.value = 'u'
      dataNoticia.value.descripcion = item.descripcion
      dataNoticia.value.titulo = item.titulo
      dataNoticia.value.id_tutorial = item.id_tutorial
      dataNoticia.value.name = item.name
    }
    function ordenarTutoriales(list) {
      listTutorialesSeccion.value = list
    }
    function showAgregarTutorial(item) {
      selected.value = item
      store.commit('someVariables/UPDATE_SHOW_ADD_TUTORIAL', true)
    }
    function showNewTutorial() {
      // console.log('unosss')
      dataNoticia.value = { ...dataNoticiaData }
      accion.value = 'i'
      // console.log(dataNoticia.value)
      store.commit('someVariables/UPDATE_SHOW_NEW_NOTICIA', true)
    }

    function showOrdenar() {
      store.commit('someVariables/UPDATE_SHOW_ORDENAR_TUTORIALES', true)
    }
    function filtrarVideosSección(listPrincipal, listSeccion) {
      return listSeccion.map(itemSeccion => {
        const itemPrincipal = listPrincipal.find(
          // eslint-disable-next-line
          item => item.id_tutorial === itemSeccion.id_tutorial
        )
        if (itemPrincipal) {
          // Combinar las propiedades del principal con las del seccion
          return {
            ...itemSeccion, // Propiedades originales de listSeccion
            url: itemPrincipal.url,
            titulo: itemPrincipal.titulo,
            descripcion: itemPrincipal.descripcion,
          }
        }
        // Si no hay coincidencia, devolver el item de listSeccion sin modificaciones
        return itemSeccion
      })
    }
    function filtrarVideosNoEstanSección(listPrincipal, listSeccion) {
      return listPrincipal.filter(
        item1 =>
          // eslint-disable-next-line
          !listSeccion.some(item2 => item1.id_tutorial === item2.id_tutorial)
        // eslint-disable-next-line
      )
    }
    async function getVideosSeccion(seccionUse) {
      listTutorialesSeccion.value = []
      seccion.value = seccionUse
      showLoadingPartidos.value = true
      const path = `ApiClientes/getTutorialesSeccion/${seccionUse}`
      const data = await getApi(URL_ADMINISTRACION, path)
      // console.log(data.data)
      listTutorialesSeccion.value = filtrarVideosSección(
        listTutoriales.value,
        // eslint-disable-next-line
        data.data
      )
      listTutorialesNoEstanSeccion.value = filtrarVideosNoEstanSección(
        listTutoriales.value,
        // eslint-disable-next-line
        data.data
      )
      showLoadingPartidos.value = false
      // console.log(listTutorialesSeccion.value)
    }
    async function getTutoriales() {
      listTutoriales.value = []
      showLoadingPartidos.value = true
      const path = 'ApiClientes/getTutoriales'
      const data = await getApi(URL_ADMINISTRACION, path)
      listTutoriales.value = data.data
      showLoadingPartidos.value = false
      getVideosSeccion('inicial')
      // console.log(listTutoriales.value)
    }

    onMounted(() => {
      getTutoriales()
    })
    const listPlayersFilter = computed(
      () =>
        // eslint-disable-next-line
        listTutoriales.value.filter(
          player =>
            // eslint-disable-next-line
            player.nombre
              .toLowerCase()
              // eslint-disable-next-line
              .includes(searchQuery.value.toLowerCase())
          // eslint-disable-next-line
        )
      // eslint-disable-next-line
    )
    const listVersionesDebug = computed(() => {
      // eslint-disable-next-line
      let lisFinal = []
      const list = listTutoriales.value.filter(player => player.tipo === 'd')
      list.forEach(element => {
        const obj = {
          label: `${element.version}`,
          value: element.id_cliente,
          version_init: element.folder_web,
          version_number: element.version,
        }
        lisFinal.push(obj)
      })
      return lisFinal
      // eslint-disable-next-line
    })
    return {
      showLoadingPartidos,
      listPlayersFilter,
      searchQuery,
      selected,
      listVersionesDebug,
      getTutoriales,
      USER,
      ROLES,
      listTutoriales,
      editarNoticia,
      showAgregarTutorial,
      getVideosSeccion,
      listTutorialesSeccion,
      listTutorialesNoEstanSeccion,
      showOrdenar,
      ordenarTutoriales,
      seccion,
      dataNoticia,
      showNewTutorial,
      accion,
      // updatedSelected,
    }
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
.etiquetas {
  display: flex;
  justify-content: center;
  font-size: 12px;
}
</style>
